<template>
  <div class="time-sheet time-sheet-submit">
    <CCard class="filter">
      <div class="filter-title">
        {{ $t("commons.label_filter_title") }}
      </div>
      <div class="filter_hr"></div>
      <div class="filter_content">
        <!-- <CCol col="12" sm="6" lg="3" class="filter_month"> -->
        <div class="filter_month">
          <div class="filter_month__title">
            {{ $t("commons.label_month") }}
          </div>
          <a-month-picker
            placeholder="MM/YYYY"
            size="large"
            :class="'month-picker__input'"
            v-model="searchData.month"
            :disabled-date="disableMonth"
            format="MM/YYYY"
            @change="search"
          >
            <template slot="suffixIcon">
              <img src="../../assets/img/calendar.svg" alt="" />
            </template>
          </a-month-picker>
        </div>
        <!-- </CCol> -->
        <!-- <CCol col="12" sm="6" lg="3" class="filter_month"> -->
        <div class="filter_month">
          <div class="filter_month__title">ID/Họ và tên</div>
          <CInput
            type="text"
            :class="'month-picker__input'"
            v-model.trim="searchData.employee_info"
            v-on:keyup.enter="search"
          />
        </div>
        <!-- </CCol> -->
        <!-- <CCol col="12" sm="6" lg="3" class="filter_month"> -->
        <div class="filter_month">
          <div class="filter_month__title">Khối</div>
          <select
            class="form-control form-group month-picker__input"
            v-model="searchData.foot_code"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option v-for="foot in foots" :key="foot.id" :value="foot.code">
              {{ foot.name }}
            </option>
          </select>
        </div>
        <!-- </CCol> -->
        <!-- <CCol col="12" sm="6" lg="3" class="filter_month"> -->
        <div class="filter_month">
          <div class="filter_month__title">Bộ phận</div>
          <select
            class="form-control form-group month-picker__input"
            v-model="searchData.division_code"
            @change="search"
          >
            <option value="0">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option
              v-for="division in filterDivision"
              :key="division.id"
              :value="division.code"
            >
              {{ division.name }}
            </option>
          </select>
        </div>
        <div class="filter_month">
          <div class="filter_month__title">
            {{ $t("label.status") }}
          </div>
          <!-- <CCol col="12" sm="6" lg="3"> -->
          <select
            class="form-control form-group"
            v-model="searchData.status"
            @change="search"
          >
            <option value="2">
              {{ $t("placeholder.label_employee_option_search") }}
            </option>
            <option value="0">{{ $t("label.unsubmit") }}</option>
            <option value="1">{{ $t("label.submit") }}</option>
          </select>
          <!-- </CCol> -->
        </div>
        <!-- </CCol> -->
      </div>
      <CRow>
        <CCol sm="12" lg="12" md="12" col="12" class="px-0 text-center">
          <CButton @click="search" class="btn-search-timesheet mr-2">
            <img src="/img/icons/search-icon.svg" alt="" />
            {{ $t("label.search") }}
          </CButton>
        </CCol>
      </CRow>
      <!-- <CRow class="justify-content-center btn-search-mb">
        <CButton @click="search" class="btn-search-timesheet">{{
          $t("label.search")
        }}</CButton>
        <CButton class="btn-reset" @click="resetForm">{{
          $t("button.label_action_reset")
        }}</CButton>
      </CRow> -->
    </CCard>
    <div class="table-list">
      <CCard>
        <CCardBody>
          <div class="option-table">
            <div class="page-title">
              {{ $t("page_title.page_timesheet_list_submit") }} ({{
                pagination.totalRecord
              }}
              / {{ pagination.totalRecordSubmit }})
              <!-- <select
                class="form-control"
                v-model="searchData.itemsPerPage"
                @change="search"
              >
                <option
                  v-for="item in listItemsPerPage"
                  :value="item"
                  :key="item"
                >
                  {{ item }}
                </option>
              </select> -->
            </div>
            <div class="remind-option">
              <router-link
                :to="{
                  name: 'time-sheets.remind-history',
                  params: { month: searchData.month },
                }"
              >
                <span class="history-btn">
                  <img src="/img/icons/history-icon.svg" alt="" />Lịch sử gửi
                  remind
                </span>
              </router-link>

              <CButton color="ml-1" class="remind-btn" @click="openRemindModal"
                ><img
                  src="/img/icons/remind-icon.svg"
                  class="mr-2"
                  alt=""
                />Remind Facon
              </CButton>
              <CButton color="ml-1" class="excel-btn" @click="testExport"
                ><img
                  src="/img/icons/excel-export-icon.svg"
                  class="mr-2"
                  alt=""
                />Export
              </CButton>
            </div>
            <!-- <template
              v-if="timeSheetSummary.data && timeSheetSummary.data.length > 0"
            >
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ $t("commons.label_text_to") }} {{ searchData.paginate.to }}
                {{ $t("commons.label_text_of") }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template> -->
            <!-- <template v-else>
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ searchData.paginate.to }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template> -->
          </div>
          <div class="form-group" style="margin-bottom: 0.5rem">
            <select
              class="form-control"
              style="width: 5%"
              v-model="searchData.itemsPerPage"
              @change="search"
            >
              <option
                v-for="item in listItemsPerPage"
                :value="item"
                :key="item"
              >
                {{ item }}
              </option>
            </select>
          </div>
          <div class="table-responsive table-ecs-container">
            <table class="table table-mobile table-tablet table-hover">
              <thead>
                <tr>
                  <th
                    width="100px"
                    @click="sortByColumn('employees.id')"
                    class="cl-pointer"
                  >
                    ID
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort('employees.id')"
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    width="100px"
                    @click="sortByColumn('employee_timesheet_submits.month')"
                    class="cl-pointer"
                  >
                    Tháng
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="
                          classStatusSort('employee_timesheet_submits.month')
                        "
                      ></CIcon>
                    </span>
                  </th>
                  <th
                    class="min-width-200 cl-pointer"
                    @click="sortByColumn('employees.name')"
                  >
                    Tên
                    <span class="icon-sort">
                      <CIcon
                        name="cil-caret-bottom"
                        :class="classStatusSort('employees.name')"
                      ></CIcon>
                    </span>
                  </th>
                  <th width="150px" class="text-center">Công tiêu chuẩn</th>
                  <th width="150px" class="text-center">Tổng Công</th>
                  <th width="200px" class="text-center">
                    Thời gian submit công
                  </th>
                  <th class="text-center">Hành động</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="timeSheetSubmits != 0">
                  <tr
                    v-for="(timeSheet, index) in timeSheetSubmits"
                    v-if="timeSheet !== null"
                    :key="timeSheet.index"
                  >
                    <td class="text-center">
                      {{ index }}
                    </td>
                    <td>{{ timeSheet.month }}</td>
                    <td>{{ timeSheet.employee.name }}</td>
                    <td class="text-center">
                      {{ timeSheet.standardAttendance }}
                    </td>
                    <td class="text-total text-center">
                      {{ timeSheet.total }}
                    </td>
                    <td class="text-center">
                      <template v-if="timeSheet.employee.submitted_at">
                        <!-- {{ timeSheet.employee.submitted_at | formatDateTime }} -->
                        {{
                          moment(
                            timeSheet.employee.submitted_at,
                            "YYYY-MM-DD HH:mm:ss"
                          ).format("HH:mm DD/MM/YYYY")
                        }}
                      </template>
                      <template v-else
                        ><span class="time-container"> - </span></template
                      >
                    </td>
                    <td class="text-total text-center">
                      <button
                        class="btn btn-outline-primary btn-sm"
                        @click="showDetailTimesheet(timeSheet)"
                      >
                        Chi Tiết
                      </button>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="13" class="text-center">
                      {{ $t("table.label_data_not_found") }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CPagination
          v-if="timeSheetSubmits"
          :activePage.sync="pagination.currentPage"
          :pages="pagination.totalPage"
          @update:activePage="fetchTimeSheetData"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
    <a-modal
      class="remind-modal"
      :centered="true"
      v-model="isShowRemindModal"
      :title="RemindModalTitle"
      on-ok="handleRemind"
      :zIndex="1030"
      :closable="true"
    >
      <template slot="footer" v-if="checkSubmit">
        <a-button
          key="submit"
          type="primary"
          class="footer-btn confirm-btn"
          @click="handleRemind"
        >
          <!--          <img src="/img/icons/checked-icon.svg" alt=""/>  -->
          Xác nhận
        </a-button>
        <a-button
          key="back"
          @click="closeRemindModal"
          class="footer-btn close-btn"
        >
          <!--          <img src="/img/icons/close-icon.svg" alt=""/> -->
          Hủy bỏ
        </a-button>
      </template>
      <template slot="footer" v-else>
        <a-button
          key="back"
          @click="closeRemindModal"
          class="footer-btn confirm-btn"
        >
          <!--          <img src="/img/icons/close-icon.svg" alt=""/> -->
          OK
        </a-button>
      </template>
      <template>
        <div class="modal-content">
          <div v-if="this.checkSubmit">
            <div class="message-warning message-not-submit-success">
              <img src="/img/icons/frame.svg" alt="" />
              Hệ thống sẽ gửi thông báo tới
              {{ Object.keys(timeSheetsUnsubmit).length }} nhân sự chưa submit
              công.
            </div>
            <div class="table-title">
              Những người trong danh sách sau sẽ nhận được tin nhắn:
            </div>
          </div>
          <div v-else>
            <div class="message-warning">
              <img src="/img/icons/frame.svg" alt="" />
              <div
                v-if="
                  searchData.month.format('MM/YYYY') ==
                  moment().format('MM/YYYY')
                "
              >
                {{ $t("popup.label_future_time_submit") }}
              </div>
              <div v-else>
                {{ $t("popup.label_expire_time_submit") }}
              </div>
            </div>
          </div>
          <div class="table-modal" v-if="this.checkSubmit">
            <table class="table-content">
              <thead class="table-header">
                <tr>
                  <th>ID</th>
                  <th>Họ và Tên</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr v-for="(value, key) in timeSheetsUnsubmit" :key="key">
                  <td>{{ key }}</td>
                  <td>
                    {{ value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </a-modal>
    <a-modal
      class="remind-modal remind-history-modal"
      :centered="true"
      v-model="isShowHistoryRemindModal"
      title="Lịch sử gửi thông báo"
      on-ok="closeHistoryRemindModal"
      :zIndex="1030"
      :closable="true"
    >
      <template slot="footer">
        <!-- <a-button key="back" @click="closeRemindModal" class="footer-btn close-btn">
          <img src="/img/icons/close-icon.svg" alt="" /> Hủy
        </a-button> -->
        <a-button
          key="submit"
          type="primary"
          class="footer-btn confirm-btn"
          @click="closeHistoryRemindModal"
        >
          <!--          <img src="/img/icons/checked-icon.svg" alt=""/> -->
          OK
        </a-button>
      </template>
      <template>
        <div class="modal-content">
          <div class="table-modal">
            <table class="table-content">
              <thead class="table-header">
                <tr>
                  <th>ID</th>
                  <th>Họ và Tên</th>
                  <th>Số lần gửi</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template
                  v-if="timeSheetHistory && timeSheetHistory.length > 0"
                >
                  <tr v-for="item in timeSheetHistory" :key="item.key">
                    <td>{{ item.employee_id }}</td>
                    <td>
                      {{ item.name }}
                    </td>
                    <td>
                      {{ item.total }}
                    </td>
                  </tr>
                </template>

                <tr v-else>
                  <td colspan="6">
                    <a-empty :image="simpleImage" :description="description" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import { Empty } from "ant-design-vue";
import moment from "moment";

export default {
  name: "TimeSheetListSubmit",
  metaInfo() {
    return {
      title: this.$t("page_title.page_timesheet_summary"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    // DatePickerFormFlex
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      description: this.$t("table.label_data_not_found"),
      searchData: {
        id: "",
        name: "",
        employee_info: "",
        foot_code: "0",
        division_code: "0",
        month: moment(),
        status: 2,
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          totalRecordSubmit: 0,
          perPage: 0,
        },
        sortColumn: "",
        sortBy: "",
      },
      checkSubmit: true,
      listData: {},
      isShowRemindModal: false,
      isShowHistoryRemindModal: false,
      isLoadingBtnRemind: false,
      export: true,
      download: true,
    };
  },
  async created() {
    this.fetchTimeSheetData();
  },
  computed: {
    ...mapGetters({
      timeSheetSubmits: "timeSheet/timeSheetSubmits",
      timeSheetHistory: "timeSheet/timeSheetHistory",
      timeSheetsUnsubmit: "timeSheet/timeSheetUnsubmit",
      pagination: "timeSheet/pagination",
      companies: "commons/companies",
      foots: "commons/foots",
      divisions: "commons/divisions",
      listItemsPerPage: "commons/listItemsPerPage",
      mustSubmit: "commons/mustSubmit",
      timeSheetsExport: "timeSheet/timeSheetsExport",
    }),
    filterDivision() {
      if (this.searchData.foot_code === "0") return this.divisions;
      return this.divisions.filter(
        (division) => division.parent_code === this.searchData.foot_code
      );
    },
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    moment,
    showDetailTimesheet(timesheet) {
      let routeData = this.$router.resolve({
        // name: "time-sheets",
        name: "time-sheets.employee-timsheet-detail",
        query: {
          id: timesheet.employee.id,
          month: String(timesheet.month),
          // foot: this.searchData.foot_code,
          // division: this.searchData.division_code,
        },
      });
      window.open(routeData.href, "_blank");
    },
    resetForm() {
      this.searchData.month = moment();
      this.searchData.company_code = "0";
      this.searchData.foot_code = "0";
      this.searchData.division_code = "0";
      this.searchData.employee_info = "";
    },

    disableMonth(current) {
      return current && current > moment().endOf("day");
    },

    RemindModalTitle() {
      return `Xác nhận gửi thông báo tháng ${this.searchData.month.format(
        "MM/YYYY"
      )}`;
    },

    async fetchTimeSheetData() {
      this.setLoading(true);
      await this.$store.dispatch("timeSheet/fetchTimeSheetSubmit", {
        ...this.pagination,
        employee_info: this.searchData.employee_info,
        division_code: this.searchData.division_code,
        foot_code: this.searchData.foot_code,
        month: moment(this.searchData.month).format("MM/YYYY"),
        perPage: this.searchData.itemsPerPage,
        status: this.searchData.status === 3 ? null : this.searchData.status,
        sortColumn: this.searchData.sortColumn,
        sortBy: this.searchData.sortBy,
      });
      this.setLoading(false);
    },

    sortByColumn(column) {
      if (this.searchData.sortColumn == column) {
        this.searchData.sortBy =
          this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      } else {
        this.searchData.sortBy = "DESC";
      }
      this.searchData.sortColumn = column;

      // this.passParamUrl();
      this.fetchTimeSheetData();
    },
    classStatusSort(column) {
      return this.searchData.sortColumn == column &&
        this.searchData.sortBy == "DESC"
        ? "sort-rotate"
        : "";
    },
    async TimeSheetsHistory() {
      await this.$store.dispatch("timeSheet/TimeSheetsHistory", {
        month: this.searchData.month.format("MM/YYYY"),
      });
    },

    async TimeSheetsUnsubmit() {
      await this.$store.dispatch("timeSheet/TimeSheetsUnsubmit", {
        ...this.pagination,
        month: moment(this.searchData.month).format("MM/YYYY"),
        perPage: this.searchData.itemsPerPage,
        status: this.searchData.status === 3 ? null : this.searchData.status,
      });
    },

    async search() {
      this.searchData.paginate.currentPage = 1;
      this.setLoading(true);
      try {
        await this.fetchTimeSheetData();
        // await this.TimeSheetsHistory();
        // await this.TimeSheetsUnsubmit();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
    async testExport() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/fetchTimeSheetsExportListSubmit", {
          ...this.pagination,
          employee_info: this.searchData.employee_info,
          division_code: this.searchData.division_code,
          foot_code: this.searchData.foot_code,
          month: moment(this.searchData.month).format("MM/YYYY"),
          perPage: this.searchData.itemsPerPage,
          export: this.export,
          download: this.download,
          status: this.searchData.status === 3 ? null : this.searchData.status,
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_popup_export_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    checkRemindSubmit() {
      var dataMonth = this.searchData.month.format("MM/YYYY");
      if (
        dataMonth != moment().subtract(1, "months").format("MM/YYYY") ||
        !this.mustSubmit
      ) {
        return (this.checkSubmit = false);
      } else {
        return (this.checkSubmit = true);
      }
    },
    openHistoryRemindModal() {
      this.TimeSheetsHistory();
      this.isShowHistoryRemindModal = true;
    },
    closeHistoryRemindModal() {
      this.isShowHistoryRemindModal = false;
    },
    openRemindModal() {
      this.checkRemindSubmit();
      this.TimeSheetsUnsubmit();
      this.isShowRemindModal = true;
    },
    closeRemindModal() {
      this.isShowRemindModal = false;
    },
    async handleRemind() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/UnsubmitRemindTimeSheet", {
          month: moment(this.searchData.month).format("MM/YYYY"),
        })
        .then(() => {
          let message = this.$t("popup.label_remind_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.isShowRemindModal = false;
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
  },
};
</script>

<style lang="scss">
.time-sheet-submit {
  input,
  select {
    border-radius: 10px !important;
    width: 100%;
    height: 40px;
  }

  .ant-calendar-picker {
    width: 100%;

    .ant-input {
      border-radius: 10px !important;
      width: 100%;
    }
  }
}

.remind-history-modal {
  .ant-modal-body {
    max-width: 450px !important;

    .modal-content {
      .table-content {
        .table-header {
          tr {
            th {
              &:first-child {
                width: 80px;
              }

              &:nth-child(2) {
                width: 230px;
              }

              &:last-child {
                width: 131px;
              }
            }
          }
        }

        .table-body {
          tr {
            td {
              border-right: 1.5px solid #efefef;
            }
          }
        }
      }
    }
  }
}

.remind-modal {
  .ant-modal-close {
    &:focus-visible,
    &:focus {
      outline: unset;
    }

    .ant-modal-close-icon {
      &:focus-visible,
      &:focus {
        outline: unset;
      }
    }
  }

  .ant-modal {
    max-width: 684px;
    width: 100% !important;

    .ant-modal-content {
      border-radius: 10px;
    }
  }

  .ant-modal-header {
    padding: 20px;
    background: #d2d6ff;
    border-bottom: 1px solid #3d4cdc;
    border-radius: 10px 10px 0 0;

    .ant-modal-title {
      color: #3d4cdc;
      font-weight: 700;
    }
  }

  .ant-modal-body {
    padding: 20px 0px;
    max-width: 440px;
    width: 100%;
    margin: 0 auto;

    .modal-content {
      .message-not-submit-success {
        color: #303c54;
        font-weight: 400;
      }

      .table-modal {
        .table-content {
          position: relative;

          .table-header {
            border-collapse: separate; /* Don't collapse */
            border-spacing: 0;

            tr {
              th {
                position: sticky;
                top: 0;
                background: #eeeeee;
                z-index: 1;
                font-size: 14px;
                box-shadow: inset 1px 0px #dddddd, 0 1px #dddddd;
                border: none;
              }
            }
          }

          .table-body {
            tr {
              border-top: unset;

              td {
                box-shadow: inset 1px -1px #dddddd;
                border-left: unset;
                font-size: 14px;
                border: none;
              }
            }
          }
        }
      }

      .table-title {
        color: #303c54;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }
    }
  }

  .ant-modal-footer {
    border-top: none;
    display: flex;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 20px;
    border-radius: 0 0 10px 10px;

    .footer-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 210px;
      width: 100%;
      font-weight: 700;
      font-size: 14px;
      border-radius: 10px;
      border: unset;
      height: 40px;

      img {
        margin-right: 5px;
      }
    }

    .close-btn {
      //border-color: #118fa6;
      color: #6f6f6f;
      background: #ececec;
      margin-left: 20px;
    }

    .confirm-btn {
      background: #3d4cdc;
      color: #ffffff;
    }
  }
}
</style>

  <style lang="scss" scoped>
.text-total {
  color: #17a896;
  font-weight: bold;
}

.time-sheet-submit {
  margin: 12px -6px 0 -6px;
}

.table-ecs-container {
  border-radius: 10px 10px 0 0;
  table-layout: auto;
}

th {
  border-right: 1px solid white;
  border-left: 1px solid white;
  background: #3488eb;
  color: #ffffff;
  text-align: center;

  &:first-child {
    border-left: 1px solid #3488eb;
  }

  &:last-child {
    border-right: 1px solid #3488eb;
  }
}

td {
  border: 1px solid;
  border-color: #d8dbe0;
}

.card {
  border: unset;
  border-radius: unset;

  &-body {
    padding: 10px 24px 0 24px;
  }
}

.table-list {
  margin: 12px -24px 0 -24px;
}

tr.day-off {
  background-color: #f0f8ff;
}

th,
td {
  vertical-align: middle !important;
}

.required,
.error-required {
  color: #dc1313;
  font-size: 13px;
}

.btn-search-timesheet {
  /* background-color: #b5dbf2; */
  margin-top: 25px;
  height: 40px;
  width: 100%;
  max-width: 210px;

  background: #3d4cdc;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
}

.btn:focus,
.btn.focus {
  box-shadow: none !important;
}

@media only screen and (max-device-width: 480px) {
  .mb-mobile-2 {
    margin-bottom: 0.5rem;
  }

  .btn-search-mb {
    margin-top: 15px;
  }
}

@media only screen and (max-device-width: 767px) {
  .py-mobile-0 {
    padding: 0 !important;
  }

  .btn-search-mb {
    margin-top: 15px;
  }

  .show-text-table {
    margin-left: 20px;
  }

  .table-mobile {
    width: 1600px;
    overflow-x: scroll;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1600px;
    overflow-x: scroll;
  }
}
</style>

  <style lang="scss" scoped>
.time-sheet-submit {
  .cl-pointer {
    svg.c-icon {
      width: 0.8rem;
      height: 0.8rem;
    }
    svg.c-icon.sort-rotate {
      transform: rotate(180deg);
    }
  }
  .filter {
    margin: -2rem -24px 0 -24px;
    padding: 19px 24px;

    &_title {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: #3d4cdc;
    }

    &_hr {
      width: 100%;
      height: 1px;
      background-color: #eaeaea;
      margin: 19px 0;
    }
    &_content {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      gap: 10px;
      .filter_month {
        width: 100%;
      }
      @media screen and (max-width: 1200px) {
        grid-template-columns: 1fr 1fr 1fr;
      }
      @media screen and (max-width: 480px) {
        grid-template-columns: 1fr 1fr;
      }
    }

    &_month {
      //max-width: 242px;

      &__title {
        font-size: 14px;
        line-height: 17px;
        color: #303c54;
        font-weight: 500;
        margin-bottom: 8px;
      }
    }
  }

  @media only screen and (max-device-width: 1024px) {
    .filter {
      margin-left: -10px;
      margin-right: -10px;
    }
  }
  .filter-title {
    //margin: 0 -15px 19px;
    //padding-bottom: 19px;
    //border-bottom: 1px solid #EAEAEA;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #3d4cdc;
  }

  .option-table {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .page-title {
      font-weight: 700;
      font-size: 18px;
      color: #3d4cdc;
    }
  }

  .remind-option {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 14px;

    .history-btn {
      display: flex;
      justify-content: center;
      margin-right: 20px;
      cursor: pointer;
      color: #303c54;

      img {
        margin-right: 8px;
      }
    }

    .remind-btn {
      padding: 6px 41.77px;
      border-radius: 10px;
      background: #ececec;
      color: #3d4cdc;
      font-weight: 700;
      font-size: 14px;
    }

    .excel-btn {
      background: #f58722;
      color: white;
      font-size: 14px;
      font-weight: 700;
      border-radius: 10px;
      width: 217px;
      margin-left: 20px;
    }
  }
}

.modal-content {
  border: none;
  font-weight: 400;
  font-size: 12px;
  color: #000000;

  .message-warning {
    display: flex;
    justify-content: center;
    font-weight: 700;
    font-size: 14px;
    color: #303c54;
    // margin-bottom: 15px;

    img {
      margin-right: 10px;
    }
  }

  .table-title {
    font-weight: 700;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 12px;
  }

  .table-modal {
    width: 100%;
    max-height: 230px;
    overflow: auto;
    border: 1px solid #efefef;
    border-radius: 10px;

    &::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #eeeeee;
      border-radius: 0 5px 5px 0px;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 5px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .table-content {
    min-width: 200px;
    width: 100%;

    .table-header {
      tr {
        th {
          padding: 10px 12px;
          border-right: 1px solid #dddddd;
          color: #303c54;
          font-weight: 700;
          background: rgba(0, 0, 0, 0.06);
          text-align: center;
        }

        th:first-child {
          border-left: unset;
          min-width: 50px;
        }

        th:last-child {
          border-right: unset;
        }
      }
    }

    .table-body {
      tr {
        border-top: 1px solid #efefef;

        td {
          padding: 10px 12px;
          border-right: 1px solid #efefef;
          text-align: center;
        }

        td:last-child {
          border-right: unset;
        }
      }
    }
  }
}
</style>
